import React from 'react';
import { type Types } from '@fiverr-private/theme';
import { Container } from '@fiverr-private/layout_components';

const DropdownSectionHeader = ({ children }: Pick<Types.Box, 'children'>) => (
  <Container color="grey_1200" paddingY="2" paddingX="4" fontSize="b_md" lineHeight="b_md" fontWeight="semibold">
    {children}
  </Container>
);

DropdownSectionHeader.displayName = 'DropdownSectionHeader';
export default DropdownSectionHeader;
